module.exports = __webpack_public_path__ + "img/within-ios-analysis.c576e56.png";